import { withRequestDeadline } from "@softmax/observatory-client/request-signal";

import { curatedText } from "@softmax/web-features/coworlds";
import { type PreviewRulesSection } from "../content/preview-details.types";
import {
  isSelfDeclaredDeprecated,
  looksLikeDeveloperDoc,
  githubRawUrl,
  looksLikeHtml,
  leadOfExternalRules,
  h1Of,
} from "./preview-rules";

export async function readExternalRulesDoc({
  signal,
  candidate,
}: {
  signal?: AbortSignal | undefined;
  candidate: {
    title: string;
    href: string;
  };
}): Promise<PreviewRulesSection | null> {
  const rawUrl = githubRawUrl(candidate.href);

  if (!rawUrl) return null;

  let response: Response;

  try {
    response = await fetch(rawUrl, {
      signal: withRequestDeadline(signal, externalRulesFetchTimeoutMs),
      cache: "no-store",
    });
  } catch {
    return null;
  }

  if (!response.ok) return null;

  const contentType = response.headers.get("content-type") ?? "";

  if (contentType.includes("text/html")) return null;

  const body = await response.text();

  if (!body || looksLikeHtml(body)) return null;

  const lead = leadOfExternalRules(body);

  if (!lead || isSelfDeclaredDeprecated(lead) || looksLikeDeveloperDoc(lead)) {
    return null;
  }

  return {
    title: h1Of(body) ?? candidate.title,
    body: curatedText(lead),
  };
}

const externalRulesFetchTimeoutMs = 5000;
